import { SectionCard } from '@atlas/ui-components'
import { type OptionCard, OptionCards } from './OptionCards'

/** The designer's verdict on the package. */
export enum SourceMaterialVerdict {
	READY = 'ready',
	ISSUE = 'issue',
}

const OPTIONS: OptionCard<SourceMaterialVerdict>[] = [
	{ value: SourceMaterialVerdict.READY, title: 'Ready to use', detail: 'Files are accessible, editable and complete' },
	{ value: SourceMaterialVerdict.ISSUE, title: 'Issue found', detail: 'Missing or non-editable files' },
]

/** The designer's choice; it moves nothing by itself, it decides where Submit sends the order. */
export function VerifySourceMaterials({
	value,
	onChange,
}: {
	value: SourceMaterialVerdict | null
	onChange: (value: SourceMaterialVerdict) => void
}) {
	return (
		<SectionCard
			title="Verify source materials"
			collapsible
			description="Open the package in Veeva and confirm the source files are accessible, editable and complete"
		>
			<OptionCards label="Source material verdict" options={OPTIONS} value={value} onChange={onChange} />
		</SectionCard>
	)
}
